import StatusLabel from "./StatusLabel";

export default StatusLabel;
